import React from "react";

function FirmItem({ firm }) {
  return (
    <div className="flex justify-between items-center">
      <div>
        <span className="font-medium text-base">{firm.firmName}</span>
        <div className="text-sm text-gray-500">
          Bayi Seri No: {firm.bayserNo || "Belirtilmemiş"}
        </div>
        {firm.firmContactNumber && (
          <div className="text-sm text-gray-500">
            Tel: {firm.firmContactNumber}
          </div>
        )}
      </div>
    </div>
  );
}

export default FirmItem;
